import { useTranslation } from "react-i18next";
import { advancedTaskHelper } from "../../../../helpers";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { ReactComponent as EmptyStateImage } from "../../../../images/noTasks.svg";

interface ToDoListEmptyStateProps {
  iconType: IconDefinition;
  pluralNameTranslationKeyIdentifier: string;
}

function ToDoListEmptyState({
  iconType,
  pluralNameTranslationKeyIdentifier,
}: ToDoListEmptyStateProps) {
  const { t } = useTranslation();
  return (
    <div className="text-center text-gray-400 grow bg-white py-2 lg:py-3">
      <div className="flex justify-center">
        <EmptyStateImage className="max-w-1/2 h-16 my-4" />
      </div>
      <div className="mt-2 text-sm">
        <span>
          {t("DashboardTaskBar.TaskType.YouHaventGotAnyActive").replace(
            "#TASK_TYPE_NAME#",
            advancedTaskHelper.ToLowerCase(pluralNameTranslationKeyIdentifier)
          )}
        </span>
      </div>
    </div>
  );
}

export default ToDoListEmptyState;
